export default "__VITE_ASSET__7d45d764__"